import classNames from "classnames";
import classes from "../styles/typography.module.scss";

export const Typography = ({size, color, children, style , className , onClick}) => {
    return (
        <div
            onClick={onClick}
            style={{ ...style , color: color ? `var(--${color})` : "inherit",}}
            className={classNames(
                {
                    [classes.headerOne]: size === "header1",
                    [classes.headerTwo]: size === "header2",
                    [classes.headerThree]: size === "header3",
                    [classes.headerFour]: size === "header4",
                    [classes.headerFive]: size === "header5",
                    [classes.bodytextlg]: size === "bodytextlg",
                    [classes.bodytextmd]: size === "bodytextmd",
                    [classes.bodytextsm]: size === "bodytextsm",
                    [classes.bodytextxs]: size === "bodytextxs",
                },
                className
            )}
        >
            {children}
        </div>
    );
};

export default Typography;
